var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "profit-loss-year" },
    [
      _c(
        "div",
        {
          staticClass: "section operations",
          staticStyle: { "margin-bottom": "1px" }
        },
        [
          _c(
            "el-form",
            { staticStyle: { "margin-bottom": "-8px" }, attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Accounting Interval" } },
                [
                  _c(
                    "el-select",
                    {
                      ref: "fromFPRef",
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "Please select" },
                      model: {
                        value: _vm.form.fromFP,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fromFP", $$v)
                        },
                        expression: "form.fromFP"
                      }
                    },
                    _vm._l(_vm.fiscalPeriods, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.fiscalPeriodLabelFun(item),
                          value: item.uuid
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "OP Dept" } },
                [
                  _c("office-department-cascader", {
                    staticStyle: { width: "160px" },
                    attrs: { placeholder: "Please input keyword" },
                    model: {
                      value: _vm.form.departmentIds,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "departmentIds", $$v)
                      },
                      expression: "form.departmentIds"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Sales" } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "160px" },
                    attrs: {
                      "callback-params": { key: "sales" },
                      "default-value": _vm.form.sales,
                      "select-type": _vm.selectTypeNames.basic_data_User,
                      "callback-method-type": "value",
                      placeholder: "Please input keyword",
                      filterable: ""
                    },
                    on: { parentCallBack: _vm.selectChangeHandler }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "el-margin",
                      attrs: { type: "primary" },
                      on: { click: _vm.doSearch }
                    },
                    [_vm._v("Search")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "el-margin",
                      attrs: { type: "primary" },
                      on: { click: _vm.newLineItems }
                    },
                    [_vm._v("New line items")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "el-margin",
                      attrs: { type: "primary" },
                      on: { click: _vm.newStatisticalItems }
                    },
                    [_vm._v("New statistical items")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1", padding: "0px" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "800px" },
            attrs: {
              "show-side-bar": false,
              "column-defs": _vm.columnDefs,
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.girdParams,
              "auto-fit-content": false,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c("statement-element-dialog", {
        attrs: {
          visible: _vm.statementElementDialog.visible,
          "atb-dictionary": _vm.atbDictionary,
          "account-set": _vm.accountSet,
          "elementformula-editable":
            _vm.statementElementDialog.elementformulaEditable,
          "statement-description-uuid":
            _vm.statementElementDialog.statementDescriptionUuid,
          "statement-description":
            _vm.statementElementDialog.statementDescription
        },
        on: {
          close: function($event) {
            _vm.statementElementDialog.visible = false
          }
        }
      }),
      _c("element-formula-new-dialog", {
        attrs: {
          visible: _vm.elementFormulaNewDialog.visible,
          "atb-dictionary": _vm.atbDictionary,
          "account-set": _vm.accountSet,
          "elementformula-editable":
            _vm.elementFormulaNewDialog.elementformulaEditable,
          "statement-description-uuid":
            _vm.elementFormulaNewDialog.statementDescriptionUuid,
          "statement-description":
            _vm.elementFormulaNewDialog.statementDescription
        },
        on: {
          close: function($event) {
            _vm.elementFormulaNewDialog.visible = false
          }
        }
      }),
      _c("element-formula-edit-dialog", {
        attrs: {
          visible: _vm.elementFormulaEditDialog.visible,
          "atb-dictionary": _vm.atbDictionary,
          "account-set": _vm.accountSet,
          "elementformula-editable":
            _vm.elementFormulaEditDialog.elementformulaEditable,
          "statement-element-description-uuid":
            _vm.elementFormulaEditDialog.statementElementDescriptionUuid,
          "statement-element-description":
            _vm.elementFormulaEditDialog.statementElementDescription,
          "statement-name": "ProfitLossYear"
        },
        on: {
          close: function($event) {
            _vm.elementFormulaEditDialog.visible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }